import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureReferralFromUrl } from "@/lib/referralTracking";

/**
 * Captura ?ref=CODIGO em qualquer rota e persiste no localStorage por 30 dias.
 * Renderiza nada — efeito colateral apenas.
 */
export function ReferralCapture() {
  const location = useLocation();
  useEffect(() => {
    captureReferralFromUrl();
  }, [location.search]);
  return null;
}
